<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <grid
      :class="[`${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__grid-content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <component
          :is="item.component"
          v-for="item in cms.content"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :class="`${name}__content`"
        />
        <div v-if="cms.background_copy" :class="`${name}__background`">
          {{ cms.background_copy }}
        </div>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/organisms/o-article-v2/o-article-v2.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-article-v2',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-article-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  // min-height: 670px;
  padding: var(--spacing-top) 0 var(--spacing-bottom);

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  &__grid {
    align-items: center;
  }

  &__grid-content {
    position: relative;
    z-index: 1;
  }

  &__background {
    @include font-family($font-family-headings, 600);
    @include font-size(128, 320px); // 8rem

    color: var(--disabled-color);
    position: absolute;
    right: 0;
    bottom: 0;
    opacity: 0.25;
    pointer-events: none;
    z-index: -1;
  }
}
@include media-breakpoint-up(md) {
  .o-article-v2 {
    &__background {
      @include font-size(192, 320px); // 12rem
    }
  }
}
@include media-breakpoint-up(lg) {
  .o-article-v2 {
    &__background {
      @include font-size(400, 320px); // 25rem
    }
  }
}
</style>
